import { EnergyModel } from "src/app/models/energy/energy-model";
import { Energy } from "src/swagger-gen/web-secured/models";

export class EnergyRepoModelMapper {

    static toEnergy(r: Energy): EnergyModel {
        return {
            category: r.category ?? null,
            type: r.type ?? null
        }
    }
}